import { getActivProfile } from "../Profiles/Profile";
import { ProfileConstant } from "./ProfileConstants";

// const baseURL = getActivProfile(ProfileConstant.Dev);


const CurrentEnv = window.location.hostname
const REACT_APP_UAT_IP = process.env.REACT_APP_UAT_IP;
const REACT_APP_DEV_IP1 = process.env.REACT_APP_DEV_IP1;
const REACT_APP_DEV_IP2 = process.env.REACT_APP_DEV_IP2;
const REACT_APP_PROD_HOST = process.env.REACT_APP_PROD_HOST;

let baseURL;

console.log(" UAT REACT_APP_UAT_IP, REACT_APP_DEV_IP1, REACT_APP_DEV_IP2, REACT_APP_PROD_HOST", REACT_APP_UAT_IP,REACT_APP_DEV_IP1, REACT_APP_DEV_IP2, REACT_APP_PROD_HOST)

switch (CurrentEnv) {
    case REACT_APP_UAT_IP:
    case REACT_APP_DEV_IP2:
        baseURL = getActivProfile(ProfileConstant.UAT);
        break;
    case REACT_APP_DEV_IP1:
        baseURL = getActivProfile(ProfileConstant.Dev);
        break;
    case REACT_APP_PROD_HOST:
        baseURL = getActivProfile(ProfileConstant.Prod);
        break;
    default:
        baseURL = getActivProfile(ProfileConstant.UAT);
}



export const Url = {

    login: baseURL + "login",
    setupMeeting: baseURL + "saveMeeting",
    editMeeting: baseURL + 'updateMeeting',
    getEmployees: baseURL + 'getEmployees',
    getDepartmentTags: baseURL + 'getDepartmentTags',
    getComplianceTags: baseURL + 'getComplianceTags',
    getControlRef: baseURL + 'getControlRef',

    // getAllUpcomingMeetingDetails: baseURL + 'getAllUpcomingMeetingDetails',
    // getAllOngoingMeetingDetails: baseURL + 'getAllOngoingMeetingDetails',
    // getAllPreviousMeetings: baseURL + 'getAllPreviousMeetings',
    getAllCancelledMeeting: baseURL + 'getAllCancelledMeeting/cancelled',
    getMeetingsByMeeetingType: baseURL + 'getMeetingsByMeeetingType',
    getMeetingsByType: baseURL + 'getMeetByRecTypeAndDate',
    cancelUpcomingMeeting: baseURL + 'makeCancelMeeting/{mid}',
    GetMeetingDetailsById: baseURL + 'getMeetingDetailsById/{mid}',
    GetMeetingMomByMeetingId: baseURL + `getViewMeetingMom/{meetingId}/{isAttendeeRequired}`,

    // MOM version control
    getMomByVersion: baseURL + `getMomByVersions/{meetingId}/{version}/{isAttendeeRequired}`,
    getMomVersionsList: baseURL + `getMomVersionsArray/{mid}`,


    editMomMeeting: baseURL + `saveMinutesOfMeeting`,
    deleteMeeting: baseURL + 'deleteMeeting/{mid}',
    getMeetingsByTagAndRec: baseURL + 'getMeetingSummaryByTagIdAndRecurrenceId/{deptTagId}/{startDate}/{endDate}',
    getControlReferenceTableData: baseURL + 'getControlReferenceDetails',
    getUserData: baseURL + 'tokenParse',
    getAllTypeOfMeeting: baseURL + 'getAllTypeOfMeeting',
    getAllTypeOfMeetingWithCount: baseURL + 'getAllTypeOfMeetingWithCount',
    getAllTagsOfMeetingWithCount: baseURL + 'getCountByDepartTagWiseBetweenDate',

    // ----------------------------------------------Calendr-----------------------------------------------
    getMeetingsByCalendarType: baseURL + 'getMeetingsByCalendarType',
    getMeetingsByCalendarTypeAndControlRef: baseURL + 'getMeetingsByCalendarTypeAndControlRefId',
    downloadIcsFile: baseURL + 'createICS/{mid}',
    getRecurranceInfoStatmt: baseURL + 'getRecurranceInfoStatmt',
    downloadMOM: baseURL + 'generatePdf/{meetingId}/{version}/{isAttendeeRequired}',
    getAllCheckList: baseURL + 'getAllCheckList/{deptId}/{year}/{quarter}/{type}',
    addTestProcedure: baseURL + 'addTestProcedure',
    deleteTestProcedureById: baseURL + 'deleteTestProcedureById/{id}',
    getAllObservationOfProcedure: baseURL + 'getObservationOfProcedureExcelStream/{deptId}/{auditYear}/{auditPeriod}',
    addAuditObservationByControlRefId: baseURL + 'addAuditObservationByControlRefId',
    downloadObservationExcelStream: baseURL + 'getObservationOfProcedureExcelStream/{deptId}/{auditYear}/{auditPeriod}',
    getAllTaskList: baseURL + 'getAllTaskList',
    getTaskBoard: baseURL + 'getTaskBoard',
    getTaskById: baseURL + 'getTaskById/{id}',
    updateTask: baseURL + 'updateTask',
    //    ------------------------------------------------AuditCal popup API's------------------------------------------------------
    saveAuditCalendar: baseURL + "saveAuditCalendar",
    updateAuditCalendar: baseURL + "updateAuditCalendar",
    getAuditCalendarByAuditId: baseURL + "getAuditCalendarByAuditId/{auditId}",
    getAuditCalendarDataByDeptIdAndYear: baseURL + "getAuditCalendarDataByDeptIdAndYear/{deptId}/{year}",
    getEmployeeListByProjectName: baseURL + 'getEmployeeListByProjectName',


    updateCheckList: baseURL + 'updateCheckList',
    updateObservationList: baseURL + 'updateObservationList',

    getAuditYear: baseURL + "getAuditYear",

    gettaskboardFilteredData: baseURL + "getTaskListByStatus/",
    getAdminPersonalTaskBoard: baseURL + "getAdminPersonalTaskBoard",
    getAdminPersonalTaskList: baseURL + "getAdminPersonalTaskList",
    getMeetingLocationList: baseURL + "getMeetingLocation",

    // ===========================Team management API's=====================================
    getTeamList: baseURL + "getTeamList",
    addQmsTeam: baseURL + "addQmsTeam",
    deleteQmsTeam: baseURL + "deleteQmsTeam/{qmsTeamId}",
    editQmsTeam: baseURL + "editQmsTeam",
    getTeamDetails: baseURL + "getTeamDetails/{projectId}/{qmsTeamId}",

    //==========================Charts API================================
    getGraphCount: baseURL + "getGraphCount",
    getEmployeeGraphCount: baseURL + "getEmployeeGraphCount/{employeeId}",
    getDueTasksForAdmin: baseURL + "getDueTasksForAdmin",
    getDueTasksForEmployee: baseURL + "/getDueTasksForEmployee/{employeeId}",
    getEmployeeGraphCountByFilter: baseURL + "getEmployeeGraphCountByFilter/{employeeId}/{type}",
    getPersonalTaskListByStatus: baseURL + "getPersonalTaskListByStatus/{status}",

    // =========================logOut API===========================
    logoutApplication: baseURL + "logoutApplication",


    // ===============================Proxy Login API===========================
    ProxyLogin: baseURL + "getProxyLogin",
}

